// @react/hooks/useAuthnOidc.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { authnOidcStore } from '@core/stores';

/**
 * React hook for  operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAuthnOidc } from '@react/hooks';
 *
 * const List = observer(() => {
 *   const store = useAuthnOidc();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAuthnOidc() {
  return authnOidcStore;
}
